import React from 'react';

const CheckMark = (fill = '#000000') => (
  <g>
    <path
      d="M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm7.28,7.44L9.64,17.08l-.06.06a.85.85,0,0,1-1.18.18l-.1-.08L4.75,13.68a.84.84,0,0,1,0-1.19.85.85,0,0,1,1.19-.05l0,.05,3,2.95,9.19-9.19a.84.84,0,0,1,1.19,1.19Z"
      fill={fill}
    />
    <path
      d="M19.28,7.44,9.64,17.08l-.06.06a.85.85,0,0,1-1.18.18l-.1-.08L4.75,13.68a.84.84,0,0,1,0-1.19.85.85,0,0,1,1.19-.05l0,.05,3,2.95,9.19-9.19a.84.84,0,0,1,1.19,1.19Z"
      fill={'white'}
    />
  </g>
);

export default CheckMark;



// WEBPACK FOOTER //
// ./src/assets/svg-icons/checkmark.js